"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MilkRunV2API = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MilkRunV2API = /*#__PURE__*/function () {
  function MilkRunV2API(_ref) {
    var customerKey = _ref.customerKey;
    (0, _classCallCheck2.default)(this, MilkRunV2API);
    this.customerKey = null;
    this.requestAuth = null;
    this.requestParameters = null;
    this.helper = new _helper.Helper();
    this.customerKey = customerKey;
    this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    this.requestParameters = (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.customerKey);
  }

  (0, _createClass2.default)(MilkRunV2API, [{
    key: "getPlan",
    value: function getPlan(payload) {
      return this.requestAuth.get('ROUTING', 'v1/core/milkrun', _objectSpread(_objectSpread({}, this.requestParameters), payload));
    }
  }, {
    key: "getTrucks",
    value: function getTrucks(_ref2) {
      var requestParameters = _ref2.requestParameters;

      var params = _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        limit: 500,
        order: 'PlateNum:ASC'
      }, requestParameters);

      return this.requestAuth.get('ROUTING', 'v1/core/trucks', params);
    }
  }, {
    key: "getAllLogs",
    value: function getAllLogs(payload) {
      return this.requestAuth.get('ROUTING', 'v1/core/orderlogs', _objectSpread(_objectSpread({}, this.requestParameters), payload));
    }
  }, {
    key: "postLog",
    value: function postLog(payload) {
      return this.requestAuth.post('ROUTING', 'v1/core/orderlog/status', _objectSpread({}, this.requestParameters), payload);
    }
  }]);
  return MilkRunV2API;
}();

exports.MilkRunV2API = MilkRunV2API;